import { useState, useEffect } from 'react';
import { getProductImage } from '../../utils/imageStorage';
import LocalImageUploader from '../../components/feature/LocalImageUploader';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useCart } from '../../hooks/useCart';

export default function ProduitCageOiseauxTrioOiseauxFleurRouge() {
  const { addItem } = useCart();
  const [quantity, setQuantity] = useState(1);
  const productId = 'cage-oiseaux-trio-oiseaux-fleur-rouge';
  const defaultImage = 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/a70bc768183598607c06cff5f92b04f3.png';
  const [productImage, setProductImage] = useState<string>(defaultImage);
  const [showImageUploader, setShowImageUploader] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      const savedImage = await getProductImage(productId);
      if (savedImage) {
        setProductImage(savedImage);
      }
    };
    loadImage();
  }, []);

  const handleImageUpdate = (newImageUrl: string) => {
    setProductImage(newImageUrl || defaultImage);
    setShowImageUploader(false);
  };

  const product = {
    id: 'cage-oiseaux-trio-oiseaux-fleur-rouge',
    name: 'Cage à oiseaux en livre plié – Trio d\'oiseaux & Fleur rouge (pièce unique)',
    price: 30,
    category: 'Cage à oiseaux',
    subcategory: 'Cage à oiseaux',
    description: "Cette cage décorative est une création artisanale réalisée à partir d'un livre entièrement plié à la main. Elle est sublimée par une grande fleur rouge aux finitions dorées, de larges feuilles vertes et un trio d'oiseaux décoratifs aux tons jaunes et rouges.",
    image: productImage,
    link: '/produit-cage-oiseaux-trio-oiseaux-fleur-rouge'
  };

  const handleAddToCart = async () => {
    const productToAdd = {
      ...product,
      image: productImage
    };
    
    addItem(productToAdd, quantity);
  };

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      <Header />

      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <nav className="flex flex-wrap items-center space-x-1 sm:space-x-2 text-xs sm:text-sm text-[#6B5E5A] mb-6 sm:mb-8">
            <a href="/" className="hover:text-[#C49B86] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Accueil
            </a>
            <i className="ri-arrow-right-s-line text-[#C49B86]"></i>
            <a href="/boutique" className="hover:text-[#C49B86] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Boutique
            </a>
            <i className="ri-arrow-right-s-line text-[#C49B86]"></i>
            <span className="text-[#C49B86] font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>Cage à oiseaux en livre plié – Trio d'oiseaux & Fleur rouge</span>
          </nav>

          <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 mb-12 sm:mb-16">
            {/* Image du produit */}
            <div className="space-y-4">
              <div className="aspect-square bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-[#C49B86]/20 relative">
                <img
                  src={productImage}
                  alt={product.name}
                  className="w-full h-full object-cover object-top cursor-pointer hover:scale-105 transition-transform duration-300"
                  onClick={() => window.open(productImage, '_blank')}
                />
                <button
                  onClick={() => setShowImageUploader(!showImageUploader)}
                  className="absolute top-4 right-4 bg-[#C49B86] text-white p-3 rounded-full hover:bg-[#B97A72] transition-colors shadow-lg"
                  title="Remplacer l'image"
                >
                  <i className="ri-image-edit-line text-xl"></i>
                </button>
              </div>
              
              {showImageUploader && (
                <div className="bg-white p-4 rounded-xl border-2 border-[#C49B86]/20">
                  <LocalImageUploader
                    productId={productId}
                    currentImage={productImage}
                    onImageUpdate={handleImageUpdate}
                  />
                </div>
              )}
            </div>

            {/* Informations du produit */}
            <div className="space-y-4 sm:space-y-6">
              <div>
                <div className="inline-block bg-[#C49B86] text-white px-3 py-1 rounded-full text-xs font-medium mb-3">
                  Pièce unique ✨
                </div>
                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#6B5E5A] mb-3 sm:mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                  {product.name}
                </h1>
                <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4 mb-4 sm:mb-6">
                  <span className="text-3xl sm:text-4xl font-bold text-[#C49B86]" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {product.price.toFixed(2)} €
                  </span>
                  <span className="text-sm text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>TTC</span>
                </div>
              </div>

              <div className="prose prose-gray max-w-none">
                <p className="text-[#6B5E5A] leading-relaxed text-base sm:text-lg mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  ✨ <strong>Cage à oiseaux en livre plié – Trio d'oiseaux & Fleur rouge (pièce unique)</strong>
                </p>
                <p className="text-[#6B5E5A] leading-relaxed text-base sm:text-lg mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Cette cage décorative est une création artisanale réalisée à partir d'un livre entièrement plié à la main. Elle est sublimée par une grande fleur rouge aux finitions dorées, de larges feuilles vertes et un trio d'oiseaux décoratifs aux tons jaunes et rouges.
                </p>
                <p className="text-[#6B5E5A] leading-relaxed text-base sm:text-lg mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  L'ensemble crée une scène poétique, joyeuse et chaleureuse, parfaite pour une décoration originale et pleine de vie.
                </p>
                <p className="text-[#6B5E5A] leading-relaxed text-base sm:text-lg mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Chaque création est unique, façonnée avec soin dans mon atelier à partir de livres recyclés. Aucune cage ne peut être reproduite à l'identique.
                </p>
                <p className="text-[#6B5E5A] leading-relaxed text-base sm:text-lg mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  🌸 <strong>Idéale pour :</strong>
                </p>
                <ul className="list-none space-y-1 text-[#6B5E5A] text-base sm:text-lg mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  <li>- Une décoration intérieure colorée et poétique</li>
                  <li>- Un cadeau artisanal original et plein de charme</li>
                  <li>- Apporter une touche florale et joyeuse à un salon, une entrée ou une chambre</li>
                </ul>
                <p className="text-[#6B5E5A] leading-relaxed text-base sm:text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  ✅ Création 100 % faite main<br />
                  ✅ Pièce unique<br />
                  ✅ Livre recyclé – démarche éco-responsable<br />
                  ✅ Décoration florale et trio d'oiseaux inclus
                </p>
              </div>

              {/* Caractéristiques */}
              <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-sm border-2 border-[#C49B86]/20">
                <h3 className="font-semibold text-[#C49B86] mb-3 sm:mb-4 text-lg sm:text-xl" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Caractéristiques
                </h3>
                <ul className="space-y-2 sm:space-y-3 text-[#6B5E5A]">
                  <li className="flex items-center text-sm sm:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <i className="ri-check-line text-[#C49B86] mr-2 sm:mr-3 text-base sm:text-lg"></i>
                    Fait main avec amour
                  </li>
                  <li className="flex items-center text-sm sm:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <i className="ri-check-line text-[#C49B86] mr-2 sm:mr-3 text-base sm:text-lg"></i>
                    Matériau : Pages de livre recyclées
                  </li>
                  <li className="flex items-center text-sm sm:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <i className="ri-check-line text-[#C49B86] mr-2 sm:mr-3 text-base sm:text-lg"></i>
                    Grande fleur rouge avec finitions dorées
                  </li>
                  <li className="flex items-center text-sm sm:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <i className="ri-check-line text-[#C49B86] mr-2 sm:mr-3 text-base sm:text-lg"></i>
                    Feuilles vertes décoratives
                  </li>
                  <li className="flex items-center text-sm sm:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <i className="ri-check-line text-[#C49B86] mr-2 sm:mr-3 text-base sm:text-lg"></i>
                    Trio d'oiseaux jaunes et rouges inclus
                  </li>
                  <li className="flex items-center text-sm sm:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <i className="ri-check-line text-[#C49B86] mr-2 sm:mr-3 text-base sm:text-lg"></i>
                    Pièce unique et poétique
                  </li>
                </ul>
              </div>

              {/* Sélection quantité et ajout panier */}
              <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-sm border-2 border-[#C49B86]/20">
                <div className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mb-4 sm:mb-6">
                  <label className="font-medium text-[#6B5E5A] text-base sm:text-lg" style={{ fontFamily: 'Playfair Display, serif' }}>Quantité :</label>
                  <div className="flex items-center border-2 border-[#C49B86]/30 rounded-lg bg-[#FAF9F8] w-fit">
                    <button
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="p-2 sm:p-3 hover:bg-[#C49B86]/10 transition-colors text-[#C49B86]"
                    >
                      <i className="ri-subtract-line text-base sm:text-lg"></i>
                    </button>
                    <span className="px-4 sm:px-6 py-2 sm:py-3 font-medium text-[#6B5E5A] text-base sm:text-lg" style={{ fontFamily: 'Playfair Display, serif' }}>{quantity}</span>
                    <button
                      onClick={() => setQuantity(quantity + 1)}
                      className="p-2 sm:p-3 hover:bg-[#C49B86]/10 transition-colors text-[#C49B86]"
                    >
                      <i className="ri-add-line text-base sm:text-lg"></i>
                    </button>
                  </div>
                </div>

                <button
                  onClick={handleAddToCart}
                  className="w-full bg-[#C49B86] text-white py-3 sm:py-4 px-4 sm:px-6 rounded-full hover:bg-[#B97A72] transition-colors font-medium text-base sm:text-lg whitespace-nowrap shadow-lg hover:shadow-xl"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <i className="ri-shopping-cart-line mr-2"></i>
                  Ajouter au panier - {(product.price * quantity).toFixed(2)} €
                </button>
              </div>

              {/* Informations livraison */}
              <div className="bg-[#EBD2CF] p-4 sm:p-6 rounded-2xl border-2 border-[#C49B86]/20">
                <h3 className="font-semibold text-[#C49B86] mb-2 sm:mb-3 text-base sm:text-lg" style={{ fontFamily: 'Playfair Display, serif' }}>
                  <i className="ri-truck-line mr-2"></i>
                  Livraison
                </h3>
                <ul className="space-y-1 sm:space-y-2 text-[#6B5E5A] text-sm sm:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  <li>• Livraison gratuite dès 15 € d'achat</li>
                  <li>• Expédition sous 2-3 jours ouvrés</li>
                  <li>• Emballage soigné et sécurisé</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
